const normalizeGroupName = (group) => {
    if (typeof group === "string") return group;
    return group?.name || "";
};

export const isPlatformAdmin = (user) => {
    const groups = Array.isArray(user?.groups) ? user.groups : [];
    return groups.some(
        (group) => normalizeGroupName(group).toLowerCase() === "admin"
    ) || user?.roleAdmin === true;
};

const assignedFieldId = (field) => {
    if (field && typeof field === "object") return field.id;
    return field;
};

/**
 * The API is the authority for tenant/asset-owner visibility. The legacy per-person field list is
 * only an additional restriction for non-admin users that actually have explicit assignments.
 */
export const filterFieldItemsForUser = (fieldItems, user) => {
    const items = Array.isArray(fieldItems) ? fieldItems : [];
    if (isPlatformAdmin(user)) return items;

    const assignedFields = Array.isArray(user?.fields) ? user.fields : [];
    if (assignedFields.length === 0) return items;

    const assignedIds = new Set(
        assignedFields
            .map(assignedFieldId)
            .filter((id) => id !== undefined && id !== null)
            .map(String)
    );

    return items.filter((item) => assignedIds.has(String(item.id)));
};
